import Creditor from '@/views/creditor/Creditor.vue'

const router = {
    path: '/creditor',
    name: 'Creditor',
    component: Creditor,
    meta: {
        title: 'Creditor'
    }
  };

export default router
